import React from "react";
import "../styles/Header.scss";
import HeaderBreadcrumb from "./HeaderBreadcrumb";
import Logout from "../Auth/Logout";
import StatusBadge from "./StatusBadge";

// ─────────────────────────────────────────────────────────────
// CommonHeader — the shared top-bar shell.
//
// Every piece is a prop so any portal can compose its own header.
// Four pieces render BY DEFAULT (no need to pass them):
//   • currentScreen  left title  — defaults to <HeaderBreadcrumb/>
//   • planInfo       plan name + days-left badge (renders when provided)
//   • profile        defaults to the user avatar / <Logout/>
//
// Optional pieces render only when passed:
//   • whatsNew        e.g. <WhatsNewPopover/>
//   • notifications   e.g. <NotificationBell/>
//   • org             e.g. the "Org: …" chip
//   • userRole        the signed-in user's role label — rendered as a badge
//   • backToDashboard e.g. a "← Back to Dashboard" button
//
// Pass `null` to any defaulted prop to hide it. Right-side order:
// plan badge → What's New → notifications → role → org → back → profile.
// ─────────────────────────────────────────────────────────────

// Plan state → StatusBadge variant: active → green, expiring → orange, expired → red.
const planVariant = (planInfo) => {
    if (planInfo?.is_expired) return 'danger';
    if (planInfo?.is_expiring_soon) return 'warning';
    return 'success';
};

export default function CommonHeader({
    currentScreen,
    planInfo,
    profile,
    whatsNew = null,
    notifications = null,
    userRole = null,
    org = null,
    backToDashboard = null,
    className = '',
    style,
}) {
    return (
        <header className={`header common-header ${className}`.trim()} style={style}>
            <div className='headerLeft'>
                {currentScreen !== undefined ? currentScreen : <HeaderBreadcrumb className='mb-0' />}
            </div>

            <div className='headerIcons'>
                {planInfo && (
                    <div
                        className="plan_info_badge"
                        style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                    >
                        <StatusBadge variant={planVariant(planInfo)} dot transform="none">
                            {planInfo.plan_name}
                        </StatusBadge>
                        <StatusBadge variant="neutral" appearance="soft" dot={false} transform="none">
                            {planInfo.is_expired
                                ? 'Expired'
                                : planInfo.display_remaining || `${planInfo.days_remaining} days left`}
                        </StatusBadge>
                    </div>
                )}
                {whatsNew}
                {notifications}
                {userRole && (
                    <StatusBadge variant="primary" appearance="soft" dot={false} transform="none">
                        {userRole}
                    </StatusBadge>
                )}
                {org}
                {backToDashboard}
                {profile !== undefined ? profile : <div className="user_profile"><Logout /></div>}
            </div>
        </header>
    );
}
